import { ContactsService } from './services/contacts.service';
import { LeftMenuService } from './services/left-menu.service';
import { SessionService } from './services/session.service';
import { AuthService } from './services/auth.service';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { reducers } from './reducers';
import { EFFECTS } from './effects';
import { UserService } from './services/user.service';
import { RegisterService } from './services/register.service';
import { UtilitiesService } from './services/utilities.servive';
import { SettingsService } from './services/settings.service';
import { AccountService } from './services/account.service';
import { SubscriptionService } from './services/subscription.service';
import { FileUploaderService } from './services/file-uploader.service';
import { ProductService } from './services/product.service';
import { PipelineService } from './services/pipeline.service';
import { VsmService } from './services/vsm.service';
import { ButtonDisablerService } from './services/button-disabler.service';

export const STORE_IMPORTS = [
  StoreModule.forRoot(reducers, {
    runtimeChecks: {
      strictActionImmutability: false,
      strictActionSerializability: false,
      strictActionTypeUniqueness: false,
      strictActionWithinNgZone: false,
      strictStateImmutability: false,
      strictStateSerializability: false,
    },
  }),
  EffectsModule.forRoot(EFFECTS),
];

export const STORE_PROVIDERS = [
  UserService,
  RegisterService,
  AuthService,
  UtilitiesService,
  SettingsService,
  SessionService,
  LeftMenuService,
  AccountService,
  ContactsService,
  SubscriptionService,
  FileUploaderService,
  PipelineService,
  ProductService,
  VsmService,
  ButtonDisablerService
];
